const lettersToSymbolTable = {
	EUR: '€',
	USD: '$',
} as const;

export const convertCurrencyLettersToSymbol = (input: string) => {
	return (lettersToSymbolTable as Record<string, string>)[input] ?? input;
};
